import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import React from 'react';
import {Alert} from '@mui/material';
import {designSystemToken, Icon} from '@lightricks/react-design-system';
import getPlatformFromIdentityProvider from '@/utils/getIPlatformFromIdentityProvider';
import {SocialNetwork} from '@/types/creatorSafetyReport';
import SocialNetworkIcon from '@/components/social-network-icon';
import styles from './ReportLastUpdated.module.scss';

dayjs.extend(isToday);
dayjs.extend(isYesterday);

interface ReportLastUpdatedProps {
  lastUpdated: Date;
  socialNetworks: SocialNetwork[];
}

function formatLastUpdated(date: Date): string {
  const d = dayjs(date);
  if (d.isToday()) {
    return `Today ${d.format('HH:mm')}`;
  }
  if (d.isYesterday()) {
    return `Yesterday ${d.format('HH:mm')}`;
  }
  return d.format('MMM D, YYYY HH:mm');
}

function ReportLastUpdated({
  lastUpdated,
  socialNetworks,
}: ReportLastUpdatedProps) {
  const uniquePlatforms = socialNetworks.reduce<string[]>((acc, network) => {
    const platform = getPlatformFromIdentityProvider(network.provider);
    if (!acc.includes(platform)) {
      acc.push(platform);
    }
    return acc;
  }, []);

  return (
    <Alert
      severity="success"
      icon={
        <Icon
          size="small"
          appearance="primary"
          name="Navigation-Shopbag-Shield-Filled"
          color={designSystemToken('semantic.fg.brand-secondary')}
        />
      }
      action={
        <div className={styles.platforms}>
          {uniquePlatforms.map((platform) => (
            <div key={platform} className={styles.platformIcon}>
              <SocialNetworkIcon
                name={platform}
                width={24}
                height={24}
                color={designSystemToken('semantic.fg.secondary')}
              />
            </div>
          ))}
        </div>
      }
      className={styles.alert}
    >
      <span className={styles.title}>
        Last updated: {formatLastUpdated(lastUpdated)}
      </span>
    </Alert>
  );
}

export default ReportLastUpdated;
